import { render, staticRenderFns } from "./ComGoodsList.vue?vue&type=template&id=d8a797e4&scoped=true&"
import script from "./ComGoodsList.vue?vue&type=script&lang=js&"
export * from "./ComGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./ComGoodsList.vue?vue&type=style&index=0&id=d8a797e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a797e4",
  null
  
)

export default component.exports